import React, { useEffect, useState } from "react";
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";
import axios from 'axios';

export default function PropertyImageGallery({ property }) {
    console.log(property)
    const [images, setImages] = useState([]);

    // Fetch images from API dynamically
    const fetchImagesFromAPI = async () => {
        if (!property?.images?.length || !property?.id) return;

        // Initialize placeholder images immediately
        const placeholderImages = property.images.map((_, index) => ({
            original: null,
            thumbnail: null,
            isLoading: true,
            index
        }));
        setImages(placeholderImages);

        // Fetch each image individually using axios
        property.images.forEach((img, index) => {
            // const url = `${process.env.REACT_APP_API_URL}api/Images/property/${property.id}/images?width=600&height=400&quality=80&imageIndex=${index}`;
            const url = `${process.env.REACT_APP_API_URL}api/Properties/${property.id}/images/${img.id}/generate?width=600&height=400&quality=80`;
            
            axios.get(url, {
                responseType: 'blob'
            })
                .then(response => {
                    const objectUrl = URL.createObjectURL(response.data);
                    
                    // Update the specific image in the array
                    setImages(prevImages => 
                        prevImages.map(img => 
                            img.index === index 
                                ? { 
                                    original: objectUrl, 
                                    thumbnail: objectUrl, 
                                    isLoading: false,
                                    index 
                                }
                                : img
                        )
                    );
                    
                })
                .catch(err => {
                    console.error(`Image ${index} failed`, err);
                    
                    // Mark as failed but keep placeholder
                    setImages(prevImages => 
                        prevImages.map(img => 
                            img.index === index 
                                ? { 
                                    original: '/ImageNotFound.png', // or a default image
                                    thumbnail: '/ImageNotFound.png',
                                    isLoading: false,
                                    failed: true,
                                    index 
                                }
                                : img
                        )
                    );
                });
        });
    };

    useEffect(() => {
        fetchImagesFromAPI();
        
        // Cleanup object URLs on unmount
        return () => {
            images.forEach(img => {
                if (img.original && img.original.startsWith('blob:')) {
                    URL.revokeObjectURL(img.original);
                }
            });
        };
    }, [property]);

    // Filter out images that are still loading and don't have valid URLs
    const validImages = images.filter(img => img.original && !img.isLoading);

    if (!property?.images?.length) {
        return (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                <div className="text-center fs-4 fw-bold text-secondary">
                    No images available
                </div>
            </div>
        );
    }

    return (
        <div>
            {validImages.length > 0 && (
                <>
                    <ImageGallery
                        items={validImages}
                        originalHeight="660"
                        thumbnailHeight="123"
                        thumbnailWidth="153"
                        showPlayButton={false}
                    />
                </>
            ) }
        </div>
    );
}








